<template>
<div>
  <div class="dialog-footer">
    <el-button size="mini" type="primary" @click="submitForm()">保存</el-button>
    <el-button size="mini" @click="initObjectList()">重置分摊对象</el-button>
  </div>
  <div style="display: flex;flex-direction: row;" ref="meterApportion">
    <div style="width: 200px;margin-top: 20px;" ref="meterApportionTree">
      <ProjectTree height="calc(50vh + 200px)" :project_id="mainObj.project_id" :checked_keys="from_data.house_ids" :is-checkbox="true" :is_submit="false" @onNode="onNodeProject"/>
    </div>
    <div class="resize" title="左右侧边栏" ref="resize">⋮</div>
    <div ref="meterApportionList" style="overflow-x: scroll;width: calc(100% - 210px);">
      <div style="width: 100%;">
        <el-descriptions class="margin-top" title="" :column="2" size="mini" border :labelStyle="{width: '100px'}">
          <el-descriptions-item label="模版名称">
            <el-input size="mini" placeholder="请输入模板名称" v-model="from_data.name" clearable></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="分摊楼栋">
            <div style="display: flex;flex-direction: row">
              <SelectProjectTreeComponent :project_id="mainObj.project_id" :checked_keys="from_data.house_ids"/>
              <el-popover
                placement="bottom"
                width="400"
                trigger="hover">
                <template #reference>
                  <el-button>添加分摊楼栋</el-button>
                </template>
                <template #default>
                  <ProjectTree :project_id="mainObj.project_id" :checked_keys="from_data.house_ids" :is-checkbox="true" @onNode="onNodeProject"/>
                </template>
              </el-popover>
            </div>
            <!--        <div style="color: #ff3d00;margin-left: 20px;">选择了下级仪表就不能选择添加收费用户，下级仪表与收费用户二选其一。</div>-->
          </el-descriptions-item>
          <el-descriptions-item label="房产类型">
            <el-checkbox-group size="mini" v-model="from_data.house_type" @change="activeFunc">
              <el-checkbox :label="1">住宅</el-checkbox>
              <el-checkbox :label="2">车位</el-checkbox>
              <el-checkbox :label="3">储藏室</el-checkbox>
              <el-checkbox :label="4">商铺</el-checkbox>
              <el-checkbox :label="5">写字楼</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
          <el-descriptions-item label="客户性质">
            <el-checkbox-group size="mini" v-model="from_data.customer_class" @change="activeFunc">
              <el-checkbox :label="1">个人客户</el-checkbox>
              <el-checkbox :label="2">企业客户</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
          <el-descriptions-item label="客户类型">
            <el-checkbox-group size="mini" v-model="from_data.customer_type" @change="activeFunc">
              <el-checkbox :label="1">业主</el-checkbox>
              <el-checkbox :label="2">租户</el-checkbox>
              <el-checkbox :label="3">住户</el-checkbox>
              <el-checkbox :label="4">共有人</el-checkbox>
              <el-checkbox :label="5">开发商</el-checkbox>
              <el-checkbox :label="9">其它</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
          <el-descriptions-item label="房态">
            <el-checkbox-group size="mini" v-model="from_data.room_status" @change="activeFunc">
              <el-checkbox :label="1">空置</el-checkbox>
              <el-checkbox :label="2">未领</el-checkbox>
              <el-checkbox :label="3">空关</el-checkbox>
              <el-checkbox :label="4">装修</el-checkbox>
              <el-checkbox :label="5">入住</el-checkbox>
              <el-checkbox :label="6">出租</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
          <el-descriptions-item label="分摊模式">
            <el-select size="mini" v-model="from_data.apportion_type" placeholder="请选择分摊模式" @change="activeFunc" class="w-200">
              <el-option
                v-for="item in [{name:'平均分摊',value:'average'},{name:'面积分摊',value:'area'},{name:'用量分摊',value:'usage'},{name:'楼层分摊',value:'floor'},{name:'通用分摊',value:'currency'}]"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="是否设置对象">
            <el-link v-if="from_data.customer_count" type="success">已设置</el-link>
            <el-link v-if="!from_data.customer_count" type="danger">未设置</el-link>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div style="margin-top: 10px;width: 100%;">
        <Apportion2 ref="Apportion2Ref" v-if="from_data.apportion_type==='average'" apportion_type="average" :project_id="mainObj.project_id" :id="mainObj.id" :fromDataWhere="from_data" @save="saveApportion"/>
        <Apportion2 ref="Apportion2Ref" v-if="from_data.apportion_type==='area'" apportion_type="area" :project_id="mainObj.project_id" :id="mainObj.id" :fromDataWhere="from_data" @save="saveApportion"/>
        <Apportion2 ref="Apportion2Ref" v-if="from_data.apportion_type==='usage'" apportion_type="usage" :project_id="mainObj.project_id" :id="mainObj.id" :fromDataWhere="from_data" @save="saveApportion"/>
        <Apportion2 ref="Apportion2Ref" v-if="from_data.apportion_type==='floor'" apportion_type="floor" :project_id="mainObj.project_id" :id="mainObj.id" :fromDataWhere="from_data" @save="saveApportion"/>
        <Apportion2 ref="Apportion2Ref" v-if="from_data.apportion_type==='currency'" apportion_type="currency" :project_id="mainObj.project_id" :id="mainObj.id" :fromDataWhere="from_data" @save="saveApportion"/>
      </div>
    </div>
  </div>

<!--  <el-tabs v-model="from_data.apportion_type" @tab-click="activeFunc">-->
<!--    <el-tab-pane label="平均分摊" name="average">-->

<!--    </el-tab-pane>-->
<!--    <el-tab-pane label="面积分摊" name="area">-->

<!--    </el-tab-pane>-->
<!--    <el-tab-pane label="用量分摊" name="usage">-->

<!--    </el-tab-pane>-->
<!--    <el-tab-pane label="楼层分摊" name="floor">-->

<!--    </el-tab-pane>-->
<!--    <el-tab-pane label="通用分摊" name="currency">-->

<!--    </el-tab-pane>-->
<!--  </el-tabs>-->
</div>
</template>

<script>
import Apportion2 from "./Apportion2";
import MeterTree from "../../meter/components/MeterTree";
import SelectMeterComponent from "../../meter/components/SelectMeterComponent";
import SelectProjectTreeComponent from "../../meter/components/SelectProjectTreeComponent";
import ProjectTree from "../../meter/components/ProjectTree";
import {CommonHelp} from "../../../../Butler/common/CommonHelp";
import MeterHttp from "../../../common/MeterHttp";
export default {
  name: "MeterApportionTemplateCustomer",
  inject:['mainObj','componentId','setComponentId','formData'],
  components: {ProjectTree, SelectProjectTreeComponent, SelectMeterComponent, MeterTree, Apportion2},
  data(){
    return{
      activeName:"average",
      from_data:{
        name:"",
        project_id:0,
        apportion_type:'average',
        apportion_fun:"",
        house_ids:"",
        customer_count:0,
        house_type:[1,2,3,4,5],
        customer_class:[1,2],
        customer_type:[1,5],
        room_status:[1,2,3,4,5,6],
        proportion_total:0,
      },
      meter_list:[]
    }
  },
  mounted() {
    const that=this;
    that.from_data.name=that.formData().name;
    that.from_data.project_id=that.mainObj.project_id;
    // that.from_data.apportion_type='average';
    that.getData();
    // that.from_data.house_ids=""
    that.dragControllerLR({
      resize:that.$refs.resize,
      iframe:that.$refs.meterApportion,
      left:that.$refs.meterApportionTree,
      right:that.$refs.meterApportionList
    },({leftWidth})=>{
      that.leftWidth=leftWidth;
    });
  },
  methods:{
    querySearchAsyncRoom(queryString, cb){
      const that=this;
      if(!queryString){
        cb([]);
      }else {
        MeterHttp.post("Meter/getMeterKeyValue?user_type="+(that.$route.query.type||0),{keyWord:queryString,project_id:that.mainObj.project_id},ret=>{
          if(ret.code) {
            cb(ret.data)
          }else {
            cb([])
          }
        });
      }
    },
    onNodeProject(data){
      let house_ids=data.map(ret=>ret.house_id);
      this.from_data.house_ids=house_ids.join(',')
      this.$refs.Apportion2Ref.getHouseCustomer(this.from_data)
    },
    activeFunc(index){
      const that=this;
      CommonHelp.throttle(function () {
        that.from_data.house_ids&&that.$refs.Apportion2Ref.getHouseCustomer(that.from_data)
      },1000,that);
    },
    submitForm(){
      const that=this;
      that.setData((data)=>{
        that.mainObj.id=data.id;
        let apportion_object_list=that.$refs.Apportion2Ref.getTableData();
        that.setApportionObject(apportion_object_list,()=>{
          that.$message.success('设置成功');
        })
        that.from_data.id=data.id;
      })
    },
    initObjectList(){
      const that=this;
      that.from_data.customer_count=0;
      that.from_data.proportion_total=0;
      let from_data=ERP.reJson(that.from_data);
      from_data.house_type=from_data.house_type.filter(ret=>ret>0).join(',');
      from_data.customer_class=from_data.customer_class.filter(ret=>ret>0).join(',');
      from_data.customer_type=from_data.customer_type.filter(ret=>ret>0).join(',');
      from_data.room_status=from_data.room_status.filter(ret=>ret>0).join(',');
      MeterHttp.post("MeterApportionTemplate/setMeter",{...from_data},ret=>{
        if(ret.code){
          that.setApportionObject([],()=>{
            that.$message.success('初始化成功');
            that.$refs.Apportion2Ref.pageChange(1);
          })
        }
      })

    },
    getData(){
      const that=this;
      MeterHttp.get("MeterApportionTemplate/getMeter",{
        project_id:that.mainObj.project_id,
        id:that.mainObj.id,
      },ret=>{
        if(ret.code){
          ret.data.house_type=(ret.data.house_type||"").split(',').map(ret=>ret*1);
          ret.data.customer_class=(ret.data.customer_class||"").split(',').map(ret=>ret*1);
          ret.data.customer_type=(ret.data.customer_type||"").split(',').map(ret=>ret*1);
          ret.data.room_status=(ret.data.room_status||"").split(',').map(ret=>ret*1);
          that.from_data=Object.assign(that.from_data,ret.data);
          that.$nextTick(function () {
            that.$refs.Apportion2Ref.getHouseCustomer(that.from_data);
          })

        }
      });
    },
    setData(callback){
      const that=this;
      let apportion_object_list=that.$refs.Apportion2Ref.getTableData();
      let apportion_config_list=that.$refs.Apportion2Ref.getApportionConfigList();
      that.from_data.customer_count=apportion_object_list.length;
      that.from_data.proportion_total=(apportion_object_list[0]||{}).total||0;
      that.from_data.apportion_fun=JSON.stringify(apportion_config_list)
      let from_data=ERP.reJson(that.from_data);
      from_data.house_type=from_data.house_type.filter(ret=>ret>0).join(',');
      from_data.customer_class=from_data.customer_class.filter(ret=>ret>0).join(',');
      from_data.customer_type=from_data.customer_type.filter(ret=>ret>0).join(',');
      from_data.room_status=from_data.room_status.filter(ret=>ret>0).join(',');
      MeterHttp.post("MeterApportionTemplate/setMeter",{...from_data},ret=>{
        if(ret.code){
          callback(ret.data)
        }
      })
    },
    setApportionObject(apportion_object_list=[],callback){
      const that=this;
      MeterHttp.post("MeterApportionTemplate/setObjectList",{
        project_id:that.mainObj.project_id,
        id:that.mainObj.id,
        apportion_object_list:JSON.stringify(apportion_object_list),
      },ret=>{
        if(ret.code){
          callback()
        }
      })
    },
    saveApportion(callback){
      const that=this;
      that.setData((data)=>{
        that.mainObj.id=data.id;
        let apportion_object_list=that.$refs.Apportion2Ref.getTableData();
        that.setApportionObject(apportion_object_list,()=>{
          typeof callback==="function"&&callback()
        })
        that.from_data.id=data.id;
      })
    },
    dragControllerLR({resize,iframe, left, right},callback) {
      const that=this;
      resize.onmousedown = function (e) {
        //颜色改变提醒
        resize.style.background = "#818181";
        let startX = e.clientX;
        resize.left = resize.offsetLeft;
        // 鼠标拖动事件
        document.onmousemove = function (e) {
          let endX = e.clientX;
          let moveLen = resize.left + (endX - startX); // （endx-startx）=移动的距离。resize[i].left+移动的距离=左边区域最后的宽度
          let maxT = iframe.clientWidth - resize.offsetWidth; // 容器宽度 - 左边区域的宽度 = 右边区域的宽度

          if (moveLen < 50) moveLen = 50; // 左边区域的最小宽度为50px
          if (moveLen > maxT - 150) moveLen = maxT - 150; //右边区域最小宽度为150px

          resize.style.left = moveLen; // 设置左侧区域的宽度

          typeof callback=== "function" && callback({
            moveLen: moveLen,
            maxT: maxT,
            leftWidth: (moveLen-5) + "px",
            rightWidth: iframe.clientWidth - moveLen - 10 + "px"
          });

          left.style.width = moveLen + "px";
          right.style.width = iframe.clientWidth - moveLen - 10 + "px";

        };
        // 鼠标松开事件
        // eslint-disable-next-line no-unused-vars
        document.onmouseup = function (evt) {
          //颜色恢复
          resize.style.background = "#d6d6d6";
          document.onmousemove = null;
          document.onmouseup = null;
          resize.releaseCapture && resize.releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
        };
        resize.setCapture && resize.setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
        return false;
      };
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common";
.dialog-footer{
  margin-bottom: 10px;
}
/* 拖拽区div样式 */
.resize {
  cursor: w-resize;
  float: left;
  position: relative;
  top: 45%;
  background-color: #d6d6d6;
  border-radius: 5px;
  width: 10px;
  height: 50px;
  background-size: cover;
  background-position: center;
  /*z-index: 99999;*/
  font-size: 32px;
  color: white;
  margin:auto 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/apportion_template/components/MeterApportionTemplateCustomer.vue